// Generated from build58 src/features/taste/persona.ts. Run scripts/generate-taste-reference.cjs.
import { getLocalizedTasteGenre } from './localization';
export const personaTypeNameKeys = {
  OVERSEAS: 'taste.persona.overseas',
  DOMESTIC: 'taste.persona.domestic',
  BORDERLESS: 'taste.persona.borderless',
  STRICT: 'taste.persona.strict',
  GENEROUS: 'taste.persona.generous',
  EARLY_ADOPTER: 'taste.persona.earlyAdopter',
  CATALOG_DIGGER: 'taste.persona.catalogDigger',
  ALBUM_PERSON: 'taste.persona.albumPerson',
  TRACK_PICKER: 'taste.persona.trackPicker',
  GENRE_LOYAL: 'taste.persona.genreLoyal',
  OMNIVORE: 'taste.persona.omnivore',
  CONTRARIAN: 'taste.persona.contrarian',
  BALANCED: 'taste.persona.balanced',
  ARTIST_LOYAL: 'taste.persona.artistLoyal',
};
const personaQuipKeys = {
  OVERSEAS: 'taste.personaQuip.overseas',
  DOMESTIC: 'taste.personaQuip.domestic',
  BORDERLESS: 'taste.personaQuip.borderless',
  STRICT: 'taste.personaQuip.strict',
  GENEROUS: 'taste.personaQuip.generous',
  EARLY_ADOPTER: 'taste.personaQuip.earlyAdopter',
  CATALOG_DIGGER: 'taste.personaQuip.catalogDigger',
  ALBUM_PERSON: 'taste.personaQuip.albumPerson',
  TRACK_PICKER: 'taste.personaQuip.trackPicker',
  GENRE_LOYAL: 'taste.personaQuip.genreLoyal',
  OMNIVORE: 'taste.personaQuip.omnivore',
  CONTRARIAN: 'taste.personaQuip.contrarian',
  BALANCED: 'taste.personaQuip.balanced',
  ARTIST_LOYAL: 'taste.personaQuip.artistLoyal',
};
const personaQuipEnglishByKorean = {
  '음악만큼은 사대주의': 'When it comes to music, your ears look abroad.',
  '국내파인 줄 알았는데 귀는 해외파': 'You thought you were homegrown, but your ears went global.',
  '외국 음악은 일단 있어 보임': 'Music from abroad gets an instant aura.',
  '좋아하는 음악을 따라가다 보니 해외': 'Following the music you love keeps taking you abroad.',
  '국내 음악 편애 중': 'Currently playing favorites with Korean music.',
  '한국 음악은 일단 가산점': 'Korean music gets a head start.',
  '우리 것이 좋은 것이여': 'Homegrown music really does hit differently.',
  '신토불이 아니겠어요?': 'Nothing quite beats homegrown music, right?',
  '여행의 끝은 우리집': 'Every musical journey leads back home.',
  '국적보다 좋은 노래가 먼저': 'A good song comes before its passport.',
  '음악 취향에 국경도 중심도 없음': 'Your taste has neither borders nor a fixed center.',
  '좋으면 어디 음악인지는 두 번째': 'If it sounds good, where it comes from comes second.',
  '국내외 구분보다 재생 버튼이 먼저': 'Play comes before the country label.',
  '3.5점이 사실상 사랑해': 'A 3.5 is basically a love letter.',
  '칭찬에 인색한 귀': 'Praise is hard-earned with these ears.',
  '별점 인플레이션 반대파': 'Firmly opposed to rating inflation.',
  '명반이라고? 내가 들어보고': 'A masterpiece? You will be the judge.',
  '5점은 죽기 전에 한 번 줄까 말까': 'Maybe one 5.0 in this lifetime.',
  '마음속에 평론지 하나 있음': 'There is a critic’s desk in your head.',
  '남들 명반에도 얄짤없음': 'Even the classics get no free pass.',
  '음악 들으면서 채점부터 함': 'You start scoring before the song ends.',
  '음악계의 박평식': 'The Park Pyeong-sik of music.',
  '좋은 게 좋은 거지': 'If it sounds good, it is good.',
  '좋으면 좋은 거지 왜 분석까지 해': 'If it sounds good, why overanalyze it?',
  '좋아하는 마음은 점수로 확실히': 'Your ratings make your enthusiasm clear.',
  '좋은 게 많아서 뭐가 문제죠': 'What is wrong with finding so much to love?',
  '발매일에 안 들으면 손해 보는 병': 'Missing release day feels like a loss.',
  '금요일만 기다리는 사람': 'You spend the week waiting for Friday releases.',
  '신보 소식에 귀가 먼저 열림': 'Your ears perk up at new-release news.',
  '묵힐 줄 모르는 귀': 'Your ears never let a new release sit unopened.',
  '신보가 뜨면 일단 재생': 'A new release appears, and you press play first.',
  '이번 주 신보도 벌써 다 들음': 'You have already heard this week’s new releases.',
  '음악도 얼리어답터': 'An early adopter, even with music.',
  '과거에서 로그아웃을 못 함': 'You cannot quite log out of the past.',
  '21세기에 잠깐 방문 중': 'You are only briefly visiting the present.',
  '신보는 숙성해서 듣는 편': 'You prefer to let new releases age first.',
  '검증된 것만 먹는 귀': 'Your ears prefer the time-tested menu.',
  '10년 지나도 신곡임': 'Ten years old still counts as new.',
  '싱글보다 앨범 단위 인간': 'You think in albums, not singles.',
  '좋은 음악은 앨범째로 기억함': 'You remember good music one album at a time.',
  '한 곡보다 한 장이 먼저 보임': 'You notice the whole record before one track.',
  '셔플 버튼과 사이가 좋지 않음': 'You and the shuffle button do not get along.',
  '좋은 곡만 골라먹는 편': 'You pick only the tracks that hit the spot.',
  '킬링트랙 사냥꾼': 'Always hunting for the standout track.',
  '한 장보다 마음에 든 한 곡': 'One great track beats a whole album.',
  '짧고 강한 한 곡에 먼저 반응함': 'A short, powerful track gets you first.',
  '좋은 곡만 정확히 챙겨감': 'You take exactly the good tracks with you.',
  '취향 확고함. 설득 불가': 'Taste firmly set. Persuasion unlikely.',
  '한 우물만 너무 잘 팜': 'You dig one musical well exceptionally deep.',
  '취향 확장보다 취향 강화 중': 'Strengthening your taste rather than widening it.',
  '새로운 장르에 입국심사가 까다로움': 'New genres face a very strict entry check.',
  '좋아하는 음악의 반경이 매우 좁고 깊음': 'Your musical radius is narrow and very deep.',
  '내 귀는 어디에나 열려 있음': 'Your ears are open to everything.',
  '오늘은 재즈 내일은 하이퍼팝': 'Jazz today, hyperpop tomorrow.',
  '장르 편식 거의 없음': 'Almost no genre pickiness here.',
  '내 취향이 뭔지 나도 모름': 'Even you cannot pin down your taste.',
  '좋으면 장르가 뭐든 상관없음': 'If it sounds good, the genre does not matter.',
  '장르 구분은 남들이 하는 것': 'Genre labels are for other people.',
  '대중평과 항상 반대로 감': 'Your ratings always seem to oppose the consensus.',
  '취향에 약간의 반골 기질': 'There is a rebellious streak in your taste.',
  '남들이 욕하면 오히려 궁금함': 'Bad reviews only make you more curious.',
  '평이 안 좋으면 더 듣고 싶어짐': 'The worse the reviews, the more you want to listen.',
  '모두가 좋아하면 일단 의심함': 'If everyone loves it, you start with questions.',
  '아직도 내 취향이 계속 바뀌는 중': 'Your taste is still changing as you go.',
  '아티스트 하나 잡으면 디스코그래피 완주': 'Once you find an artist, you finish the discography.',
  '팬심과 평가는 별개라고 주장함': 'You insist fandom and ratings are separate matters.',
  '전작이 좋으면 신작도 믿고 시작': 'A great previous album earns the next one your trust.',
  '한 번 실망하면 오래 기억함': 'One disappointment stays with you for a long time.',
  '최애에게 더 가혹한 타입': 'You judge your favorites even more harshly.',
};
const evidenceKeys = {
  'taste.evidence.regionShare': 'taste.evidence.regionShare',
  'taste.evidence.regionAverage': 'taste.evidence.regionAverage',
  'taste.evidence.regionArtists': 'taste.evidence.regionArtists',
  'taste.evidence.regionRecent': 'taste.evidence.regionRecent',
  'taste.evidence.borderlessCounts': 'taste.evidence.borderlessCounts',
  'taste.evidence.borderlessAverageDifference': 'taste.evidence.borderlessAverageDifference',
  'taste.evidence.earlyAdopter': 'taste.evidence.earlyAdopter',
  'taste.evidence.catalogDigger': 'taste.evidence.catalogDigger',
  'taste.evidence.albumPerson': 'taste.evidence.albumPerson',
  'taste.evidence.trackPicker': 'taste.evidence.trackPicker',
  'taste.evidence.genreLoyal': 'taste.evidence.genreLoyal',
  'taste.evidence.omnivoreDistinct': 'taste.evidence.omnivoreDistinct',
  'taste.evidence.omnivoreTopShare': 'taste.evidence.omnivoreTopShare',
  'taste.evidence.contrarian': 'taste.evidence.contrarian',
  'taste.evidence.averageRating': 'taste.evidence.averageRating',
  'taste.evidence.communityLower': 'taste.evidence.communityLower',
  'taste.evidence.communityHigher': 'taste.evidence.communityHigher',
  'taste.evidence.communityClose': 'taste.evidence.communityClose',
  'taste.evidence.artistLoyal': 'taste.evidence.artistLoyal',
};
// Unselected examples, never invented runner-up scores or secondary diagnoses.
export function getArchivePersonaOptions(persona, locale, t) {
  const axes = [
    ['OVERSEAS', 'DOMESTIC', 'BORDERLESS'],
    ['STRICT', 'GENEROUS', 'BALANCED'],
    ['EARLY_ADOPTER', 'CATALOG_DIGGER', 'ARTIST_LOYAL'],
    ['ALBUM_PERSON', 'TRACK_PICKER', 'OMNIVORE'],
    ['GENRE_LOYAL', 'OMNIVORE', 'ARTIST_LOYAL'],
    ['CONTRARIAN', 'BALANCED', 'STRICT'],
  ];
  const names = (
    axes.find((axis) => axis.includes(persona.key)) ?? Object.keys(personaTypeNameKeys)
  )
    .filter((key) => key !== persona.key)
    .slice(0, 2)
    .map((key) => t(personaTypeNameKeys[key]));
  const boundaries = [
    '음악만큼은 사대주의',
    '국내 음악 편애 중',
    '여행의 끝은 우리집',
    '3.5점이 사실상 사랑해',
    '좋은 게 좋은 거지',
    '발매일에 안 들으면 손해 보는 병',
    '과거에서 로그아웃을 못 함',
    '싱글보다 앨범 단위 인간',
    '좋은 곡만 골라먹는 편',
    '취향 확고함. 설득 불가',
    '내 귀는 어디에나 열려 있음',
    '대중평과 항상 반대로 감',
    '아직도 내 취향이 계속 바뀌는 중',
    '아티스트 하나 잡으면 디스코그래피 완주',
  ];
  const keys = [
    'OVERSEAS',
    'DOMESTIC',
    'BORDERLESS',
    'STRICT',
    'GENEROUS',
    'EARLY_ADOPTER',
    'CATALOG_DIGGER',
    'ALBUM_PERSON',
    'TRACK_PICKER',
    'GENRE_LOYAL',
    'OMNIVORE',
    'CONTRARIAN',
    'BALANCED',
    'ARTIST_LOYAL',
  ];
  const all = Object.keys(personaQuipEnglishByKorean),
    index = keys.indexOf(persona.key);
  const options =
    index < 0
      ? []
      : all.slice(
          all.indexOf(boundaries[index]),
          index + 1 < boundaries.length ? all.indexOf(boundaries[index + 1]) : undefined,
        );
  const quip = getLocalizedTastePersonaQuip(persona, locale, t);
  const quips = [
    ...new Set(
      [...options, ...all].map((value) =>
        locale === 'ko' ? value : personaQuipEnglishByKorean[value],
      ),
    ),
  ]
    .filter((value) => value !== quip)
    .slice(0, 2);
  return { names, quips };
}
const localizedRegion = (value, t) =>
  value === 'KR'
    ? t('taste.domestic')
    : value === 'GLOBAL'
      ? t('taste.international')
      : (value ?? '');
export function getLocalizedTastePersonaTypeName(persona, t) {
  return t(personaTypeNameKeys[persona.key] ?? 'taste.persona.balanced');
}
export function getLocalizedTastePersonaQuip(persona, locale, t) {
  if (locale === 'ko' && persona.title.trim()) return persona.title;
  if (locale === 'en' && persona.title.trim()) {
    const localizedVariant = personaQuipEnglishByKorean[persona.title.trim()];
    if (localizedVariant) return localizedVariant;
  }
  return t(personaQuipKeys[persona.key] ?? 'taste.personaQuip.balanced');
}
export function getLocalizedTasteEvidence(persona, taste, locale, t) {
  if (persona.evidenceMessages?.length) {
    return persona.evidenceMessages
      .flatMap((item, index) => {
        const key = evidenceKeys[item.code];
        if (!key) return locale === 'ko' ? [persona.evidence[index] ?? ''] : [];
        const params = {
          ...item.params,
          preferredRegion: localizedRegion(item.params.preferredRegion, t),
          otherRegion: localizedRegion(item.params.otherRegion, t),
          genre: item.params.genre
            ? getLocalizedTasteGenre(item.params.genre, locale)
            : t('taste.oneGenre'),
          artist: item.params.artist || t('taste.oneArtist'),
        };
        return [t(key, params)];
      })
      .filter(Boolean);
  }
  if (locale === 'ko' && persona.evidence.length) return persona.evidence;
  const difference = Math.abs(taste.communityDifference).toFixed(1);
  const communityEvidence =
    taste.communityDifference <= -0.05
      ? t('taste.evidence.communityLower', { difference })
      : taste.communityDifference >= 0.05
        ? t('taste.evidence.communityHigher', { difference })
        : t('taste.evidence.communityClose', { difference });
  return [
    communityEvidence,
    t('taste.evidence.averageRating', {
      ratingCount: taste.ratingCount,
      averageRating: taste.averageRating.toFixed(1),
    }),
  ];
}
export function getTastePersonaPresentation(taste) {
  if (!taste?.isReady) return undefined;
  if (taste.persona) return taste.persona;
  const titleVariants = {
    STRICT: [
      '3.5점이 사실상 사랑해',
      '칭찬에 인색한 귀',
      '별점 인플레이션 반대파',
      '명반이라고? 내가 들어보고',
    ],
    GENEROUS: [
      '좋은 게 좋은 거지',
      '좋으면 좋은 거지 왜 분석까지 해',
      '좋아하는 마음은 점수로 확실히',
    ],
    BALANCED: ['좋은 게 좋은 거지', '내 취향이 뭔지 나도 모름'],
    INSUFFICIENT: ['내 취향이 뭔지 나도 모름'],
  };
  const variants = titleVariants[taste.ratingStyle];
  const fingerprint =
    taste.ratingCount +
    Math.round(taste.averageRating * 10) +
    Math.round((taste.communityDifference + 5) * 10) +
    taste.topGenres.reduce((sum, item) => sum + item.count, 0) +
    taste.topDecades.reduce((sum, item) => sum + item.count, 0);
  const title = variants[Math.abs(fingerprint) % variants.length];
  const communityEvidence =
    taste.communityDifference <= -0.05
      ? `회원 평균보다 앨범마다 평균 ${Math.abs(taste.communityDifference).toFixed(1)}점 더 낮게 평가했어요.`
      : taste.communityDifference >= 0.05
        ? `회원 평균보다 앨범마다 평균 ${taste.communityDifference.toFixed(1)}점 더 높게 평가했어요.`
        : `회원 평균과의 앨범별 평균 점수 차이는 ${Math.abs(taste.communityDifference).toFixed(1)}점이에요.`;
  return {
    key: taste.ratingStyle,
    title,
    rarityPercent: null,
    raritySampleSize: 0,
    evidence: [
      communityEvidence,
      `전체 ${taste.ratingCount}개 평가의 평균은 ${taste.averageRating.toFixed(1)}점이에요.`,
    ],
  };
}
